export const ASSUMPTION_FIELDS = `
  id
  projectId
  number
  description
  assignedRole
  status
  isVerificationRequired
  exceptionStatus
  exceptionReason
  exceptionUntilDate
  createdAt
  updatedAt
  createdBy
  updatedBy
`;
